module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmory imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmory exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		Object.defineProperty(exports, name, {
/******/ 			configurable: false,
/******/ 			enumerable: true,
/******/ 			get: getter
/******/ 		});
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 43);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

module.exports = require("template-view");

/***/ },
/* 1 */
/***/ function(module, exports) {

module.exports = require("b3nd");

/***/ },
/* 2 */
/***/ function(module, exports) {

module.exports = require("underscore");

/***/ },
/* 3 */
/***/ function(module, exports) {

module.exports = require("compose-class-names");

/***/ },
/* 4 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"badgeTrade":"src-views-MessageSummary-style---badgeTrade---3_OuL","mcMessageSummary":"src-views-MessageSummary-style---mcMessageSummary---kNbyt","mcMessage":"src-views-MessageSummary-style---mcMessage---1oiTz","mcMessageBodyWrapper":"src-views-MessageSummary-style---mcMessageBodyWrapper---2WSIw","mcMessageHeader":"src-views-MessageSummary-style---mcMessageHeader---2uvej","attachmentErrorList":"src-views-MessageSummary-style---attachmentErrorList---1xm88","mcDisplayName":"src-views-MessageSummary-style---mcDisplayName---vfQDh","mcMessageBody":"src-views-MessageSummary-style---mcMessageBody---1GvUw","mcComposeControls":"src-views-MessageSummary-style---mcComposeControls---1hK4F","mcHasAttachment":"src-views-MessageSummary-style---mcHasAttachment---2exkf","mcMessageAttachIcon":"src-views-MessageSummary-style---mcMessageAttachIcon---1w0sl","showFlaggedMessage":"src-views-MessageSummary-style---showFlaggedMessage---2uqiX","mcAttachmentList":"src-views-MessageSummary-style---mcAttachmentList---2pPdO","numCollapsedIndicator":"src-views-MessageSummary-style---numCollapsedIndicator---2iis9","mcSentByCurrentUser":"src-views-MessageSummary-style---mcSentByCurrentUser---1l1CG","numCollapsedIndicatorTextWrapper":"src-views-MessageSummary-style---numCollapsedIndicatorTextWrapper---16Cj2","mcMessageBodyPlaceholder":"src-views-MessageSummary-style---mcMessageBodyPlaceholder---18NZ0","mcAttachmentFilename":"src-views-MessageSummary-style---mcAttachmentFilename---2gCw8","mcAttachmentImage":"src-views-MessageSummary-style---mcAttachmentImage---3ijZC","mcAttachmentLoading":"src-views-MessageSummary-style---mcAttachmentLoading---3IxqZ","mcAttachmentFileSize":"src-views-MessageSummary-style---mcAttachmentFileSize---3z4_i","mcAttachmentIcon":"src-views-MessageSummary-style---mcAttachmentIcon---2LpFf","attachmentListDisplay":"src-views-MessageSummary-style---attachmentListDisplay---2JMWZ","mcAttachmentListUgc":"src-views-MessageSummary-style---mcAttachmentListUgc---3hn19","mcAttachmentRow":"src-views-MessageSummary-style---mcAttachmentRow---JzKZX","mcAttachmentItem":"src-views-MessageSummary-style---mcAttachmentItem---2FPfP","mcAttachmentFileName":"src-views-MessageSummary-style---mcAttachmentFileName---1Xh6n","mcComposeAttachButton":"src-views-MessageSummary-style---mcComposeAttachButton---1V3qu","mcComposeAttachIcon":"src-views-MessageSummary-style---mcComposeAttachIcon---3Nr4u","mcComposeSend":"src-views-MessageSummary-style---mcComposeSend---3_D07","mcComposeSendContainer":"src-views-MessageSummary-style---mcComposeSendContainer---Rzndb","privateOfferIndicator":"src-views-MessageSummary-style---privateOfferIndicator---3Csxe","mcAttachmentListDisplay":"src-views-MessageSummary-style---mcAttachmentListDisplay---2YGRw","mcDisplayDate":"src-views-MessageSummary-style---mcDisplayDate---CZzq4","semiCollapsedOnly":"src-views-MessageSummary-style---semiCollapsedOnly---3Ydnp","privateOfferIcon":"src-views-MessageSummary-style---privateOfferIcon---2Ifnc","privateOfferPrice":"src-views-MessageSummary-style---privateOfferPrice---3vEKL","messageFlaggedIcon":"src-views-MessageSummary-style---messageFlaggedIcon---qJfoV"};

/***/ },
/* 5 */
/***/ function(module, exports) {

module.exports = require("copy-text");

/***/ },
/* 6 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"badgeTrade":"src-views-Conversation-style---badgeTrade---1XAW5","mcAllConversationsBlock":"src-views-Conversation-style---mcAllConversationsBlock---11C93","mcConversationAlertContainer":"src-views-Conversation-style---mcConversationAlertContainer---1k0K-","alert":"src-views-Conversation-style---alert---1MLIK","mcBodyContainer":"src-views-Conversation-style---mcBodyContainer---1IPwx","mcUnavailableContainer":"src-views-Conversation-style---mcUnavailableContainer---2KAJu","mcUnvailableMessageSub":"src-views-Conversation-style---mcUnvailableMessageSub---wQTc0","cantShowConversationMessage":"src-views-Conversation-style---cantShowConversationMessage---1MmZx","mcConversationWrapper":"src-views-Conversation-style---mcConversationWrapper---1yBOA","mcConversationFooter":"src-views-Conversation-style---mcConversationFooter---19m1Y","mcConversationFilterAlert":"src-views-Conversation-style---mcConversationFilterAlert---tGRPM","mcConversationToolbar":"src-views-Conversation-style---mcConversationToolbar---1w7eM","mcConversationToolbarItemDisabled":"src-views-Conversation-style---mcConversationToolbarItemDisabled---npgNA","mcConversationReported":"src-views-Conversation-style---mcConversationReported---3fKZG","fa":"src-views-Conversation-style---fa----E6a4","mcBuyerConversation":"src-views-Conversation-style---mcBuyerConversation---UdSl0","alertAction":"src-views-Conversation-style---alertAction---21J4Z","conversationHeadsUp":"src-views-Conversation-style---conversationHeadsUp---286Ej","expandCollapseAll":"src-views-Conversation-style---expandCollapseAll---dqWF1","underneathConversation":"src-views-Conversation-style---underneathConversation---3udfU","alertContainer":"src-views-Conversation-style---alertContainer---OAGYl","exclamationIcon":"src-views-Conversation-style---exclamationIcon---M0DQV","circleIcon":"src-views-Conversation-style---circleIcon---K3Yzq"};

/***/ },
/* 7 */
/***/ function(module, exports) {

module.exports = require("backbone-model");

/***/ },
/* 8 */
/***/ function(module, exports) {

module.exports = require("bubble-event");

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var momentLocaleBuilder = __webpack_require__(42);
var moment = __webpack_require__(41);
var locales = {};
locales.en = {};
locales.inlineDatesAdverb = Object.assign({}, locales.inlineDates, {
    calendar: {
        sameDay: '[at] h:mmA',
        lastDay: '[on] MMMM D',
        nextDay: '[on] MMMM D',
        lastWeek: '[on] MMMM D',
        nextWeek: '[on] MMMM D',
        sameElse: function sameElse(now) {
            return '[on] MMMM D' + (moment(now).diff(this, 'months') >= 6 ? ' YYYY' : '');
        }
    },
    relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: "seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    }
});
locales.inlineDates = {
    calendar: {
        sameDay: 'h:mmA',
        lastDay: 'MMMM D',
        nextDay: 'MMMM D',
        lastWeek: 'MMMM D',
        nextWeek: 'MMMM D',
        sameElse: function sameElse(now) {
            return 'MMMM D' + (moment(now).diff(this, 'months') >= 6 ? ' YYYY' : '');
        }
    },
    relativeTime: Object.assign({}, locales.inlineDatesAdverb.relativeTime, {
        future: "%s",
        past: "%s"
    })
};
locales.inbox = {
    calendar: {
        sameDay: 'h:mmA',
        lastDay: 'dddd',
        nextDay: 'dddd',
        lastWeek: 'MMMM D',
        nextWeek: 'MMMM D',
        sameElse: function sameElse(now) {
            return 'MMMM D' + (moment(now).diff(this, 'months') >= 6 ? ' YYYY' : '');
        }
    }
};
locales.inboxMobile = Object.assign({}, locales.inbox, {
    calendar: Object.assign({}, locales.inbox.calendar, {
        lastDay: 'ddd',
        nextDay: 'ddd',
        lastWeek: 'MMM D',
        nextWeek: 'MMM D',
        sameElse: function sameElse(now) {
            return 'MMM D' + (moment(now).diff(this, 'months') >= 6 ? ' YYYY' : '');
        }
    })
});
module.exports = momentLocaleBuilder(locales);

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var composeClassNames = __webpack_require__(3);
var css = composeClassNames(__webpack_require__(26), __webpack_require__(4));
var AttachmentView = module.exports = {};
var TemplateView = __webpack_require__(0);
var template = __webpack_require__(32);
var defaultIconClass = 'fa-file-o';
var bind = __webpack_require__(1);
var fileTypeToIconClassMap = {
    'application/pdf': 'fa-file-pdf-o',
    "application/msword": 'fa-file-word-o',
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": 'fa-file-word-o',
    "application/vnd.ms-excel": 'fa-file-excel-o',
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": 'fa-file-excel-o',
    //TODO: remove these duplicate mappings once services return MIME types for attachments
    'PDF': 'fa-file-pdf-o',
    'DOC': 'fa-file-word-o',
    'SPREADSHEET': 'fa-file-excel-o'
};

AttachmentView.Thumbnail = TemplateView.extend({
    initialize__: function initialize__(options) {
        bind(this);
        this.el.classList.add(css.attachmentImageWrapper);
        return options;
    },

    template: {
        local: css,
        src: template.thumbnail
    }
});
AttachmentView.Document = TemplateView.extend({
    template: {
        local: css,
        src: template.normal
    },
    initialize__: function initialize__(options) {
        bind(this);
        return options;
    },
    fileTypeToIconClass: function fileTypeToIconClass(fileType) {
        return fileTypeToIconClassMap[fileType] || defaultIconClass;
    },
    templateVars__: function templateVars__(obj) {
        return Object.assign({
            iconClass: this.fileTypeToIconClass(this.model.get('attachmentType'))
        }, obj);
    }
});
AttachmentView.Loading = TemplateView.extend({
    template: {
        local: css,
        src: template.loading
    }
});
AttachmentView.buildAttachmentByModel = function (attachmentModel) {
    var Constructor = AttachmentView.Loading;
    var attachmentType = attachmentModel.get('attachmentType');
    if ('IMAGE' === attachmentType) {
        Constructor = AttachmentView.Thumbnail;
    } else if (attachmentType) {
        Constructor = AttachmentView.Document;
    }
    return new Constructor({ model: attachmentModel });
};

/***/ },
/* 11 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"verticallyCentered":"src-views-InboxWrapper-style---verticallyCentered---2E4xh","horizontallyRight":"src-views-InboxWrapper-style---horizontallyRight---3ID5-","horizontallyCentered":"src-views-InboxWrapper-style---horizontallyCentered---nMmCz","verticallyHorizontallyCentered":"src-views-InboxWrapper-style---verticallyHorizontallyCentered---11cGH","inbox":"src-views-InboxWrapper-style---inbox---U_kT8","mcUnreadMessage":"src-views-InboxWrapper-style---mcUnreadMessage---1SEGx","mcHeader":"src-views-InboxWrapper-style---mcHeader---1k5zB","mcFilterLabel":"src-views-InboxWrapper-style---mcFilterLabel---3e2zN","alertContainer":"src-views-InboxWrapper-style---alertContainer---3S1pv node_modules-scss-alignment-transforms-index---horizontallyCentered---OykGB","close":"src-views-InboxWrapper-style---close---3z2W0","alertAction":"src-views-InboxWrapper-style---alertAction---2g0RC","heading":"src-views-InboxWrapper-style---heading---1KHIE","inboxPanel":"src-views-InboxWrapper-style---inboxPanel---3osEQ","mcInboxEmptyContainer":"src-views-InboxWrapper-style---mcInboxEmptyContainer---W6jaB","mcInboxEmptyMessage":"src-views-InboxWrapper-style---mcInboxEmptyMessage---19k3K","mcInboxEmptyDivider":"src-views-InboxWrapper-style---mcInboxEmptyDivider---3Iyfe","mcInboxEmptyLinkContainer":"src-views-InboxWrapper-style---mcInboxEmptyLinkContainer---22wCz","mcInboxEmptyLink":"src-views-InboxWrapper-style---mcInboxEmptyLink---15xOp","mcItemsContainer":"src-views-InboxWrapper-style---mcItemsContainer---1SqYs"};

/***/ },
/* 12 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mcBrowseHeader":"src-views-MessageCenter-style---mcBrowseHeader---2TEMQ","totalUnreadConversationCount":"src-views-MessageCenter-style---totalUnreadConversationCount---1fqcH"};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

_ = __webpack_require__(2);
module.exports = {
    "template": function(obj) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class="' +
((__t = ( obj.local.mcConversationWrapper )) == null ? '' : __t) +
' wrapper' +
((__t = ( obj.isUnavailable ? ' is-unavailable' : '' )) == null ? '' : __t) +
'">\n        <div class="' +
((__t = ( obj.messageLocation )) == null ? '' : __t) +
'"></div>\n        <div data-append=\'conversationHeader\'></div>\n        <div class="' +
((__t = ( obj.local.mcBodyContainer )) == null ? '' : __t) +
'">\n            <div class="row">\n                <div class="col-xs-12 col-md-8 col-md-push-2" data-append=\'notificationMsg\'></div>\n                <div class="' +
((__t = ( obj.local.mcMessagesColumn )) == null ? '' : __t) +
' col-xs-12 col-md-8 col-md-push-4">\n                    ';
 if (obj.isUnavailable) { ;
__p += '\n                        <div class="' +
((__t = ( obj.local.mcUnavailableContainer )) == null ? '' : __t) +
'">\n                            <div class="' +
((__t = ( obj.local.mcUnvailableMessage )) == null ? '' : __t) +
'">' +
((__t = ( obj.copy('unavailableMessage') )) == null ? '' : __t) +
'</div>\n                            <div class="' +
((__t = ( obj.local.mcUnvailableMessageSub )) == null ? '' : __t) +
'">' +
((__t = ( obj.copy('unavailableMessageSub') )) == null ? '' : __t) +
'</div>\n                        </div>\n                    ';
 } ;
__p += '\n                    <div data-append=\'headsUps\' class=\'gtm-message-detail-header\'></div>\n                    <div class=\'' +
((__t = ( obj.local.expandCollapseAll )) == null ? '' : __t) +
'\' data-model-bind=\'text: model.expandCollapseText, click: view.toggleExpandCollapse\'></div>\n                    <div data-append=\'messages\'></div>\n                    <div class=\'' +
((__t = ( obj.local.mcConversationFooter )) == null ? '' : __t) +
'\'>\n                        <span class="' +
__e( obj.local.alertContainer ) +
'" data-append=\'alertIcon\'></span>\n                        <span class="' +
((__t = ( obj.local.mcConversationFilterAlert )) == null ? '' : __t) +
'">\n                            <span class=\'' +
((__t = ( obj.local.underneathConversation )) == null ? '' : __t) +
'\' data-append=\'underneath\'></span>\n                        </span>\n                        <span class=\'' +
((__t = ( obj.local.mcConversationToolbar )) == null ? '' : __t) +
'\'>\n                            ';
 if (obj.messages) { ;
__p += '\n                            <span data-modal=\'flagConversation\' class=\'gtm-modal-trigger\' data-modal-name=\'report conversation\' data-modal-trigger=\'hyperlink\' data-model-bind=\'css: {"' +
((__t = ( obj.local.mcConversationReported )) == null ? '' : __t) +
'": computed.userHasReportedConversation}, attr: {"data-modal": computed.userHasReportedConversation ? "alreadyReportedConversation" : "flagConversation"}\'>\n                                <span data-model-bind=\'text: (computed.userHasReportedConversation ? "reported" : "report") + " conversation"\'></span>\n                            </span>\n                            ';
 } ;
__p += '\n                        </span>\n                    </div>\n                </div>\n                <div class="col-xs-12 col-md-4 col-md-pull-8" data-append="sidePiece"></div>\n            </div>\n        </div>\n    </div>\n    <div data-append="bottomSection"></div>\n';
return __p
}
};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _bubbleEvent = __webpack_require__(8);

var _bubbleEvent2 = _interopRequireDefault(_bubbleEvent);

var _composeClassNames = __webpack_require__(3);

var _composeClassNames2 = _interopRequireDefault(_composeClassNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var css = (0, _composeClassNames2.default)(__webpack_require__(27), __webpack_require__(4));
var bind = __webpack_require__(1);
var MessageAttachmentView = __webpack_require__(10);
var template = __webpack_require__(33).attachmentIndicator;
module.exports = MessageAttachmentView.Document.extend({
    events: {
        'click [data-name=try-again]': function clickDataNameTryAgain() {
            this.model.save();
        },
        'click [data-name=remove-attachment]': function clickDataNameRemoveAttachment() {
            this.removeAttachment();
        }
    },
    template__: {
        src: template,
        local__: css
    },
    updateProgress: function updateProgress() {
        var uploadProgress = '';
        var uploadTotal = this.model.get('upload-total');
        if (!uploadTotal) {
            return;
        }
        uploadProgress += Math.floor(this.model.get('upload-sent') * 100 / uploadTotal);
        uploadProgress += '%';
        this.el.querySelector('[name=upload-progress]').textContent = uploadProgress;
    },
    removeAttachment: function removeAttachment() {
        return (0, _bubbleEvent2.default)(this.el, 'remove-attachment', this.model);
    },
    initialize__: function initialize__(options) {
        this.model.on('change:upload-sent', this.updateProgress, this); // TODO: handle this with bindings
        bind(this);
        return options;
    }
}, {
    newsy: 'AttachmentIndicator'
});

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateView = __webpack_require__(0);

var _templateView2 = _interopRequireDefault(_templateView);

var _composeClassNames = __webpack_require__(3);

var _composeClassNames2 = _interopRequireDefault(_composeClassNames);

var _style = __webpack_require__(4);

var _style2 = _interopRequireDefault(_style);

var _style3 = __webpack_require__(28);

var _style4 = _interopRequireDefault(_style3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _templateView2.default.extend({
    template: {
        local: (0, _composeClassNames2.default)(_style2.default, _style4.default)
    }
});

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateView = __webpack_require__(0);

var _templateView2 = _interopRequireDefault(_templateView);

var _template = __webpack_require__(13);

var _style = __webpack_require__(6);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _templateView2.default.extend({
    template: {
        src: _template.template,
        local: _style2.default,
        messageLocation: '.' + _style2.default.mcConversationAlertContainer
    }
});

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateView = __webpack_require__(0);

var _templateView2 = _interopRequireDefault(_templateView);

var _style = __webpack_require__(12);

var _style2 = _interopRequireDefault(_style);

var _style3 = __webpack_require__(6);

var _style4 = _interopRequireDefault(_style3);

var _composeClassNames = __webpack_require__(3);

var _composeClassNames2 = _interopRequireDefault(_composeClassNames);

var _template = __webpack_require__(13);

var _backboneModel = __webpack_require__(7);

var _b3nd = __webpack_require__(1);

var _b3nd2 = _interopRequireDefault(_b3nd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _templateView2.default.extend({
    initialize__: function initialize__(options) {
        this.model = new _backboneModel.Model();
        // b3nd this view here because its template declares b3ndings.
        // Otherwise, the parent view will try to evaluate the b3ndings and get very confused.
        (0, _b3nd2.default)(this);
        return options;
    },

    template: {
        src: _template.template,
        local: (0, _composeClassNames2.default)(_style2.default, _style4.default)
    }
});

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _template = __webpack_require__(34);

var TemplateView = __webpack_require__(0);
var css = __webpack_require__(29);
var copyText = __webpack_require__(5)();
var bind = __webpack_require__(1);
var OfferDiscountAmounts = __webpack_require__(25);

var PRIVATE_OFFER_NOTIFICATION_TYPE = 'newDealerOffer';
var SHOW_DISCOUNT_NOTIFICATION_TYPE = 'newDealerOfferDiscount';
var MARK_SHIPPED_NOTIFICATION_TYPE = 'markShippedNotification';
var PRICE_TYPE_RETAIL = 'RETAIL';
var PRICE_TYPE_SALE = 'WEEKLY_SALE';
var PRICE_TYPE_NET = 'NET';
var ITEM_PUR = 'Price Upon Request';
var ITEM_SOLD = 'Sold';

var ConversationHeadsUpView = module.exports = TemplateView.extend({
    template: {
        local: css,
        src: _template.template
    },
    initialize: function initialize(options) {
        var _this = this;

        if (!this.model) {
            throw new Error("ConversationHeadsUpView must be constructed with a model");
        }
        this.context = options.context;
        this.props = Object.assign({}, options.props);
        if (!this.context) {
            throw new Error('ConversationHeadsUpView view requires options.context');
        }
        this._copyText = (options.copyText || copyText).extend({
            netPriceLabel: 'Net Price',
            salePriceLabel: 'Sale Price',
            listPriceLabel: 'List Price',
            netLabel: 'net',
            listLabel: 'list'
        });
        this._messageCenter = options.messageCenter;
        this._item = this.model.get('item');
        this._itemStatus = this._item && this._item.getItemHidePriceStatus();
        this._buyerIsTrade = Boolean(this.model.get('members').find(function (member) {
            var roles = member.get('user').get('roles');
            if (!roles) {
                return undefined;
            }
            return Boolean(roles.find(function (role) {
                return role.get('name') === 'B_TRADE_BUYER';
            }));
        }));

        ConversationHeadsUpView.__super__.initialize.apply(this, arguments);
        this._bindApi = bind(this);
        this._bindApi.off(); // MCPERSON-2486: opt in to model change binding via .on()
        this.model.on('change:transaction', function () {
            return _this._bindApi.forceUpdate();
        });
        return options;
    },
    templateVars__: function templateVars__(obj) {
        return Object.assign({
            isSoldIndividually: this.props.isSoldIndividually,
            thumbnail: this.props.thumbnail,
            pdpUrl: this.props.pdpUrl,
            prices: this._getPricesArray()
        }, obj);
    },
    _getOfferDisplayVars: function _getOfferDisplayVars() {
        var notificationDetails = { notificationMsg: '', offerExpDateTxt: '' };
        var transaction = this.model.get('transaction');
        var offerDetails = transaction ? transaction.getOfferDetails() : {};
        var offer = offerDetails.offer;
        var offerAmounts = offerDetails.offerAmounts;

        if (!offer || !offerAmounts) {
            return notificationDetails;
        }

        var transactionSummary = transaction.get('summary');
        /* istanbul ignore next */
        var transactionItemPriceType = transactionSummary ? transactionSummary.get('itemPrice.type') : undefined;
        var copyKeyPrefix = transaction.isBuyerInitiatedTx() ? 'buyer' : 'dealer';
        var offerExpiredOrCanceledOtherOverride = this._copyText.get(copyKeyPrefix + 'OfferExpiredOrCanceledOtherOverride');
        var offerPassedOverride = this._copyText.get(copyKeyPrefix + 'OfferPassedOverride');
        var showPrice = !this._itemStatus;

        var notificationType = offer.offerDisplayStatus({ transaction: transaction });
        var displayOffer = this._getFormattedPrice({ financialAmount: offerAmounts, className: 'item-offer-price' });
        var displayDiscount = void 0;
        var pcsNotification = void 0;
        var priceType = void 0;
        var discountOffMultiplier = void 0;
        var displayDiscountPercent = void 0;

        if (!notificationType) {
            return notificationDetails;
        }

        if (showPrice && notificationType === PRIVATE_OFFER_NOTIFICATION_TYPE) {
            displayDiscount = this._getFormattedPrice({
                financialAmount: new OfferDiscountAmounts(transactionSummary.get('offerDiscountAmount')),
                className: 'item-offer-price'
            });
            discountOffMultiplier = parseFloat(transactionSummary.get('offerDiscountPercentage'));
            displayDiscountPercent = Math.floor(discountOffMultiplier * 100) + '%';
        }

        if (displayDiscount) {
            /* istanbul ignore next */
            priceType = this._copyText.get(transactionItemPriceType === PRICE_TYPE_NET ? 'netLabel' : 'listLabel');
            if (discountOffMultiplier > 0) {
                notificationType = SHOW_DISCOUNT_NOTIFICATION_TYPE;
            }
            if (offerAmounts.getAmountIn('USD') > 5000 && !this._buyerIsTrade) {
                pcsNotification = this._copyText.get('pcsNotification');
            }
        }

        if (this._canMarkOrderShipped) {
            notificationType = MARK_SHIPPED_NOTIFICATION_TYPE;
        }

        /* istanbul ignore next */
        if (this.props.isSoldIndividually) {
            var perItem = this._copyText.get('per item');
            displayOffer = displayOffer + ' ' + perItem;
            displayDiscount = displayDiscount ? displayDiscount + ' ' + perItem : undefined;
            displayDiscountPercent = displayDiscountPercent ? displayDiscountPercent + ' ' + perItem : undefined;
        }

        notificationDetails.pcsNotification = pcsNotification;
        notificationDetails.offerExpDateTxt = offerDetails.offerExpDateTxt;
        notificationDetails.notificationMsg = this._copyText.get(notificationType, { obj: {
                txId: transaction.get('id'),
                displayOffer: displayOffer,
                displayDiscount: displayDiscount,
                displayDiscountPercent: displayDiscountPercent,
                offerExpiredOrCanceledOtherOverride: offerExpiredOrCanceledOtherOverride,
                offerPassedOverride: offerPassedOverride,
                priceType: priceType,
                detailsLinkClassName: css.headsUpViewDOMT
            } });

        return notificationDetails;
    },
    _getPricesArray: function _getPricesArray() {
        var prices = [];
        var showPrice = !this._itemStatus;
        if (!this._item) {
            return prices;
        }

        var salePrice = this._item.getPriceByType(PRICE_TYPE_SALE);
        var retailPrice = this._item.getPriceByType(PRICE_TYPE_RETAIL);
        var netPrice = this._item.getPriceByType(PRICE_TYPE_NET);

        var initialPrice = void 0;
        if (salePrice) {
            initialPrice = {
                label: this._copyText.get('salePriceLabel'),
                value: this._getFormattedPrice({ financialAmount: salePrice.get('amount') }),
                type: PRICE_TYPE_SALE
            };
        } else if (showPrice) {
            initialPrice = {
                label: this._copyText.get('listPriceLabel'),
                value: this._getFormattedPrice({ financialAmount: retailPrice.get('amount') }),
                type: PRICE_TYPE_RETAIL
            };
        } else {
            initialPrice = { label: this._itemStatus };
        }

        var isTrade = this._buyerIsTrade && this._item.isFurniture();
        var transaction = this.model.get('transaction');
        var offerDetails = transaction ? transaction.getOfferDetails() : {};
        var offer = offerDetails.offer;
        var offerAmounts = offerDetails.offerAmounts;

        if (initialPrice.label === ITEM_SOLD) {
            prices.push(initialPrice);
            return prices;
        }

        if (isTrade && netPrice && this._isNetPriceEnabled() && initialPrice.type !== PRICE_TYPE_SALE) {
            // Don't show "Price Upon Request" if net price was uploaded
            if (initialPrice.label !== ITEM_PUR) {
                prices.push(initialPrice);
            }

            prices.push({
                label: this._copyText.get('netPriceLabel'),
                value: this._getFormattedPrice({ financialAmount: netPrice.get('amount') }),
                type: PRICE_TYPE_NET,
                callout: 'listedNetPriceCallout'
            });
        } else {
            prices.push(initialPrice);
        }

        if (offer && offerAmounts && transaction.buyerCanAcceptPrivateOffer()) {
            prices.push({
                label: this._copyText.get(isTrade ? 'offerPriceTradeLabel' : 'offerPriceLabel'),
                value: this._getFormattedPrice({ financialAmount: offerAmounts })
            });
        }

        return prices;
    },
    _isNetPriceEnabled: function _isNetPriceEnabled() {
        return true;
    },

    computeds: {
        offerDisplay: function offerDisplay() {
            return this._getOfferDisplayVars();
        }
    }
});
module.exports.priceTypes = {
    PRICE_TYPE_RETAIL: PRICE_TYPE_RETAIL,
    PRICE_TYPE_SALE: PRICE_TYPE_SALE,
    PRICE_TYPE_NET: PRICE_TYPE_NET
};
module.exports.constants = {
    PRIVATE_OFFER_NOTIFICATION_TYPE: PRIVATE_OFFER_NOTIFICATION_TYPE,
    SHOW_DISCOUNT_NOTIFICATION_TYPE: SHOW_DISCOUNT_NOTIFICATION_TYPE,
    MARK_SHIPPED_NOTIFICATION_TYPE: MARK_SHIPPED_NOTIFICATION_TYPE,
    PRICE_TYPE_RETAIL: PRICE_TYPE_RETAIL,
    PRICE_TYPE_SALE: PRICE_TYPE_SALE,
    PRICE_TYPE_NET: PRICE_TYPE_NET,
    ITEM_PUR: ITEM_PUR,
    ITEM_SOLD: ITEM_SOLD
};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var css = __webpack_require__(30);
var momentLocales = __webpack_require__(9);
var template = __webpack_require__(35);
var TemplateView = __webpack_require__(0);
var bind = __webpack_require__(1);
var copyText = __webpack_require__(5)();
var ellipsis = __webpack_require__(38);
var bubble = __webpack_require__(8);

var ConversationSummary = module.exports = TemplateView.extend({
    events: {
        "click": function click() {
            bubble(this.el, "showConversation", this.model.id);
        }
    },
    template: {
        local: css,
        src: template.conversationSummary
    },
    initialize: function initialize(options) {
        var _this = this;

        this.on('parentResized', function () {
            return ellipsis(_this._conversationBodySummary);
        });
        this._copyText = options.copyText || copyText;
        this._imagesHosts = options.imagesHosts;
        this._transaction = this.model.get('transaction');
        if (this._transaction) {
            this._offer = this._transaction.getMostRecentOffer();
        }
        ConversationSummary.__super__.initialize.call(this, options);
        this._conversationBodySummary = this.$('.' + css.mcConversationBodySummary);
        this.trigger('parentResized');
        bind(this);
        return options;
    },
    indicators: function indicators() {
        return [{
            template: template.indicators
        }];
    },
    scope: function scope() {
        return {
            indicatorsMobile: this.indicators(),
            indicatorsDesktop: this.indicators()
        };
    },

    templateVars__: function templateVars__(obj) {
        var seller = this.model.getOriginalSeller();
        var item = this.model.get('item');
        var templateData = Object.assign(this._getStatusMessage(), {
            displayDate: momentLocales.inbox(obj.latestMessageReceivedAt).calendar(),
            displayDateMobile: momentLocales.inboxMobile(obj.latestMessageReceivedAt).calendar(),
            countUpClockDays: 0
        });

        if (item) {
            templateData.thumbnail = item.getImageUrl({ position: 1, size: 'small' });
            templateData.itemDealerReference = item.get('dealerReference');
        } else if (seller) {
            var preferences = seller.get('user.sellerPreferences');
            if (preferences && preferences.scrollLogo) {
                templateData.thumbnail = preferences.scrollLogo;
            }
        }
        return Object.assign({}, obj, templateData, {
            otherMemberDisplayName: this.model.getOtherMemberDisplayName(),
            copy: this._copyText.get.bind(this._copyText)
        });
    },

    _getStatusMessage: function _getStatusMessage() {
        if (!this._transaction) {
            return {};
        }
        if (this._transaction.isCanceled()) {
            return {};
        }
        // Order is important here since a confirmed transaction has also completed checkout
        if (this._transaction.isConfirmed()) {
            return {
                statusMessage: copyText.get('order complete'),
                statusComplete: true
            };
        }
        if (this._transaction.isCheckoutComplete()) {
            return { statusMessage: copyText.get('order pending') };
        }
        if (!this._offer) {
            return {};
        }
        if (!this._offer.isExpired()) {
            return {
                statusMessage: copyText.get('offer pending')
            };
        }
        return {};
    }
}, {
    newsy: 'ConversationSummary'
});

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateView = __webpack_require__(0);

var _templateView2 = _interopRequireDefault(_templateView);

var _style = __webpack_require__(31);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _templateView2.default.extend({
    template: {
        local: _style2.default
    }
});

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _bubbleEvent = __webpack_require__(8);

var _bubbleEvent2 = _interopRequireDefault(_bubbleEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var forEach = __webpack_require__(39);
var invert = __webpack_require__(40);
var TemplateView = __webpack_require__(0);
var b3nd = __webpack_require__(1);
var copyText = __webpack_require__(5)();
var templates = __webpack_require__(36);
var allValue = 'all';
var unreadValue = 'showUnreadOnly';

var trackingValueMap = {
    'all': 'all',
    'showUnreadOnly': 'unread'
};

var InboxFilterView = module.exports = TemplateView.extend({
    events: {
        'change #conversationFilter': function changeConversationFilter(event) {
            var val = event.target.value;
            var prefix = trackingValueMap[val] || '';
            var label = prefix + ' clicked - dropdown';
            this.filter(val);
            // todo: remove once we're using native click event bubbling to track events
            (0, _bubbleEvent2.default)(this.el, 'changeConversationFilter', label);
        },
        'click .mc-filter-button-value': function clickMcFilterButtonValue(event) {
            var target = event.target;
            event.preventDefault();
            this.filter(target.getAttribute('data-value'));
        },
        'filter': function filter(event) {
            this.model.set(event.detail);
        }
    },

    tagName: 'span',

    initialize: function initialize(options) {
        this._isBuyer = options.isBuyer;
        // TODO: set template in admin / dotcom subclasses
        this.template = templates['conversationFilter' + (this._isBuyer ? 'Select' : 'Dropdown')];
        this.filters = {};
        this.filters[allValue] = copyText.get('filterAll');
        this.filters[unreadValue] = copyText.get('filterUnread');
        if (!this._isBuyer) {
            this.filters.showNeverRespondedOnly = copyText.get('filterNeedsResponse');
        }
        InboxFilterView.__super__.initialize.apply(this, arguments);
        b3nd(this);
    },
    computeds: {
        selectedfilterLabel: function selectedfilterLabel() {
            return this.mapSelectedFilter().label;
        },
        selectedfilterValue: function selectedfilterValue() {
            return this.mapSelectedFilter().value;
        }
    },
    filter: function filter(selectedFilter) {
        var params = {
            params: {},
            pageStart: 0
        };
        forEach(this.filters, function (label, value) {
            if (value !== allValue) {
                params.params[value] = 'N';
            }
        });
        if (selectedFilter !== allValue) {
            params.params[selectedFilter] = 'Y';
        }
        (0, _bubbleEvent2.default)(this.el, 'filter', params);
    },

    mapSelectedFilter: function mapSelectedFilter() {
        var pagerParams = this.model.get('params');
        var selectedFilterObj = {};
        selectedFilterObj.value = invert(pagerParams).Y || allValue;
        selectedFilterObj.label = this.filters[selectedFilterObj.value];
        return selectedFilterObj;
    },

    templateVars__: function templateVars__(obj) {
        return Object.assign({}, obj, {
            filters: this.filters,
            selectedFilter: this.mapSelectedFilter()
        });
    }
});

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateView = __webpack_require__(0);

var _templateView2 = _interopRequireDefault(_templateView);

var _style = __webpack_require__(11);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _templateView2.default.extend({
    template: {
        local: _style2.default
    }
});

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateView = __webpack_require__(0);

var _templateView2 = _interopRequireDefault(_templateView);

var _style = __webpack_require__(12);

var _style2 = _interopRequireDefault(_style);

var _style3 = __webpack_require__(11);

var _style4 = _interopRequireDefault(_style3);

var _style5 = __webpack_require__(6);

var _style6 = _interopRequireDefault(_style5);

var _composeClassNames = __webpack_require__(3);

var _composeClassNames2 = _interopRequireDefault(_composeClassNames);

var _template = __webpack_require__(37);

var _backboneModel = __webpack_require__(7);

var _b3nd = __webpack_require__(1);

var _b3nd2 = _interopRequireDefault(_b3nd);

var _copyText = __webpack_require__(5);

var _copyText2 = _interopRequireDefault(_copyText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var copyText = (0, _copyText2.default)();

var MessageCenterView = _templateView2.default.extend({
    initialize: function initialize() {
        this.state = new _backboneModel.Model();
        MessageCenterView.__super__.initialize.apply(this, arguments);
        (0, _b3nd2.default)(this);
    },

    template: {
        src: _template.messageCenter,
        local: (0, _composeClassNames2.default)(_style2.default, (0, _composeClassNames2.default)(_style4.default, _style6.default))
    },
    templateVars: function templateVars(obj) {
        return Object.assign({}, obj, {
            copy: copyText.get.bind(copyText)
        });
    }
});
exports.default = MessageCenterView;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateView = __webpack_require__(0);

var _templateView2 = _interopRequireDefault(_templateView);

var _style = __webpack_require__(4);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _templateView2.default.extend({
    template: {
        local: _style2.default
    }
});

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var Model = __webpack_require__(7).Model;

module.exports = Model.extend({
    initialize: function initialize(attrs) {
        this.set('convertedAmounts', new Model(attrs.convertedAmounts));
    },

    getCurrency: function getCurrency() {
        return this.get('currency');
    },
    localizedAmount: function localizedAmount() {
        // admin function stubbed to prevent errors
        return false;
    }
});

/***/ },
/* 26 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"attachmentImageWrapper":"src-views-Attachment-style---attachmentImageWrapper---2BKtR"};

/***/ },
/* 27 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mcAttachmentRemove":"src-views-AttachmentIndicator-style---mcAttachmentRemove---krgow","mcAttachmentThumbnail":"src-views-AttachmentIndicator-style---mcAttachmentThumbnail---3MMjx","attachmentErrorList":"src-views-AttachmentIndicator-style---attachmentErrorList---2aUPe","mcAttachmentUploadProgress":"src-views-AttachmentIndicator-style---mcAttachmentUploadProgress---2kblJ"};

/***/ },
/* 28 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mcMessageSummary":"src-views-ComposeMessage-style---mcMessageSummary---2F1it","mcComposing":"src-views-ComposeMessage-style---mcComposing---1UBth","mcComposeControls":"src-views-ComposeMessage-style---mcComposeControls---3-N2n","mcMessage":"src-views-ComposeMessage-style---mcMessage---2FrEm","attachmentErrorList":"src-views-ComposeMessage-style---attachmentErrorList---2AvXz","mcMessageHeader":"src-views-ComposeMessage-style---mcMessageHeader---1b81d","mcMessageBodyWrapper":"src-views-ComposeMessage-style---mcMessageBodyWrapper---13Mm3","mcMessageBody":"src-views-ComposeMessage-style---mcMessageBody---zND6J"};

/***/ },
/* 29 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mcHeadsUp":"src-views-ConversationHeadsUp-style---mcHeadsUp---Jw6Cn","headsUpTopline":"src-views-ConversationHeadsUp-style---headsUpTopline---11iNC","headsUpExpDate":"src-views-ConversationHeadsUp-style---headsUpExpDate---2Glo1","headsUpNotif":"src-views-ConversationHeadsUp-style---headsUpNotif---1JoIX","itemOfferPrice":"src-views-ConversationHeadsUp-style---itemOfferPrice---i6klC","headsUpPCS":"src-views-ConversationHeadsUp-style---headsUpPCS---28AEW","headsUpPcs":"src-views-ConversationHeadsUp-style---headsUpPCS---28AEW","headsUpContent":"src-views-ConversationHeadsUp-style---headsUpContent---2lfEI","headsUpThumbnail":"src-views-ConversationHeadsUp-style---headsUpThumbnail---1WnGf","headsUpInfo":"src-views-ConversationHeadsUp-style---headsUpInfo---TqZZq","headsUpTitle":"src-views-ConversationHeadsUp-style---headsUpTitle---2X_Zs","headsUpPrice":"src-views-ConversationHeadsUp-style---headsUpPrice---1h-1F","itemAskingPrice":"src-views-ConversationHeadsUp-style---itemAskingPrice---1uCBV","priceLabel":"src-views-ConversationHeadsUp-style---priceLabel---hW_B7","headsUpCta":"src-views-ConversationHeadsUp-style---headsUpCta---3qt5d","headsUpHasExp":"src-views-ConversationHeadsUp-style---headsUpHasExp---2Pmyd","headsUpViewDOMT":"src-views-ConversationHeadsUp-style---headsUpViewDOMT---1aRyG","headsUpViewDomt":"src-views-ConversationHeadsUp-style---headsUpViewDOMT---1aRyG","shippingCopy":"src-views-ConversationHeadsUp-style---shippingCopy---SUGbu"};

/***/ },
/* 30 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"verticallyCentered":"src-views-ConversationSummary-style---verticallyCentered---3qBbz","horizontallyRight":"src-views-ConversationSummary-style---horizontallyRight---3KH2y","horizontallyCentered":"src-views-ConversationSummary-style---horizontallyCentered---Rjckx","verticallyHorizontallyCentered":"src-views-ConversationSummary-style---verticallyHorizontallyCentered---30Gww","statusMessage":"src-views-ConversationSummary-style---statusMessage---7LmVL","mcToFromLine":"src-views-ConversationSummary-style---mcToFromLine---31Vqd","mcConversationSummary":"src-views-ConversationSummary-style---mcConversationSummary---2QrRq","bgColorReadMessage":"src-views-ConversationSummary-style---bgColorReadMessage---2tfkp","mcConversationSummaryOverlay":"src-views-ConversationSummary-style---mcConversationSummaryOverlay---3-7Hf","mcInboxCol":"src-views-ConversationSummary-style---mcInboxCol---3WHpv","mcInboxRightColContents":"src-views-ConversationSummary-style---mcInboxRightColContents---2KEV9","otherPersonsName":"src-views-ConversationSummary-style---otherPersonsName---3svrN","messagePreviewRow":"src-views-ConversationSummary-style---messagePreviewRow---20SZF","thumbnail":"src-views-ConversationSummary-style---thumbnail---2w5NI","mcSummaryIndicator":"src-views-ConversationSummary-style---mcSummaryIndicator---fH1R-","messageIndicators":"src-views-ConversationSummary-style---messageIndicators---1I3ZB","offerLabel":"src-views-ConversationSummary-style---offerLabel---37QFa","statusColumn":"src-views-ConversationSummary-style---statusColumn---1YLnR","statusWrapper":"src-views-ConversationSummary-style---statusWrapper---251JY","statusPending":"src-views-ConversationSummary-style---statusPending---n9jGw","statusComplete":"src-views-ConversationSummary-style---statusComplete---2C2B2","replyIndicator":"src-views-ConversationSummary-style---replyIndicator---13UDa","unreadIndicator":"src-views-ConversationSummary-style---unreadIndicator---3uAyu"};

/***/ },
/* 31 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"flagConversation":"src-views-FlagConversation-style---flagConversation---21V_K","mcRcReason":"src-views-FlagConversation-style---mcRcReason---1akp4","mcRcExplanation":"src-views-FlagConversation-style---mcRcExplanation---R-wWc"};

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

_ = __webpack_require__(2);
module.exports = {
    "thumbnail": function(obj) {
var __t, __p = '', __e = _.escape;
__p += '\n    <div>\n        <span data-model-bind="visible: model.processed === \'N\'">\n           <span class="' +
((__t = ( obj.local.mcAttachmentImage )) == null ? '' : __t) +
' ' +
((__t = ( obj.local.mcAttachmentLoading )) == null ? '' : __t) +
' text-center">\n               <i class="fa fa-spinner fa-pulse fa-2x"></i>\n            </span>\n        </span>\n        <span data-model-bind="visible: model.processed === \'Y\'">\n           <a href="' +
__e( obj.originalPath ) +
'" target="_blank">\n               <img class="' +
((__t = ( obj.local.mcAttachmentImage )) == null ? '' : __t) +
'" data-model-bind="\n                   attr:{ src: model.processed === \'Y\' ? model.thumbnailPath : \'\'}\n               ">\n           </a>\n        </span>\n    </div>\n';
return __p
},
    "normal": function(obj) {
var __t, __p = '', __e = _.escape;
__p += '\n    <div class="' +
((__t = ( obj.local.mcAttachmentRow )) == null ? '' : __t) +
'">\n        <a class=\'' +
((__t = ( obj.local.mcAttachmentFilename )) == null ? '' : __t) +
'\' href="' +
__e( obj.originalPath ) +
'" target="_blank">\n            <strong>' +
__e( obj.displayName ) +
'</strong>\n        </a>\n        <span class="' +
((__t = ( obj.local.mcAttachmentFileSize )) == null ? '' : __t) +
'">' +
__e( obj.displaySize ) +
'</span>\n        <span><i class="' +
((__t = ( obj.local.mcAttachmentIcon )) == null ? '' : __t) +
' fa fa-lg ' +
__e( obj.iconClass ) +
'"></i></span>\n    </div>\n';
return __p
},
    "loading": function(obj) {
var __t, __p = '', __e = _.escape;
__p += '\n    <div class="' +
((__t = ( obj.local.mcAttachmentRow )) == null ? '' : __t) +
'">\n        <span class="' +
((__t = ( obj.local.mcAttachmentFilename )) == null ? '' : __t) +
'">\n            ' +
__e( obj.displayName ) +
'\n        </span>\n        <span><i class="' +
((__t = ( obj.local.mcAttachmentIcon )) == null ? '' : __t) +
' fa fa-spinner fa-pulse"></i></span>\n    </div>\n';
return __p
}
};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

_ = __webpack_require__(2);
module.exports = {
    "attachmentIndicator": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class=\'' +
((__t = ( obj.local.mcAttachmentItem )) == null ? '' : __t) +
' row cf neue\'>\n        <div class=\'col-xs-7\'>\n            <strong class=\'' +
((__t = ( obj.local.mcAttachmentFileName )) == null ? '' : __t) +
'\' data-model-bind="text : model.fileName"></strong>\n            <span class=\'' +
((__t = ( obj.local.mcAttachmentFileSize )) == null ? '' : __t) +
' text-muted\' data-model-bind="text : model.displaySize"></span>\n        </div>\n        <div class=\'col-xs-5\'>\n            <div class="pull-right">\n                <span data-model-bind="visible : model.uploadStatus === \'pending\' || undefined === model.dir">\n                    <progress class=\'' +
((__t = ( obj.local.mcAttachmentUploadProgress )) == null ? '' : __t) +
'\'\n                              name=\'upload-progress\'\n                              data-model-bind="attr : {max : model[\'upload-total\'], value : model[\'upload-sent\']}">\n                        sent <span name=\'upload-sent\'></span> bytes\n                    </progress> <!-- TODO: use this polyfill if people complain about this: http://lea.verou.me/2011/07/a-polyfill-for-html5-progress-element-the-obsessive-perfectionist-way/ -->\n                </span>\n                <span data-model-bind="visible : model.uploadStatus === \'rejected\'">\n                    <i class="fa fa-exclamation-triangle"></i> upload failed <span data-name=\'try-again\' class=\'' +
((__t = ( obj.local.tryAgain )) == null ? '' : __t) +
'\'>try again</span>\n                </span>\n                <span data-model-bind="visible : model.uploadStatus === \'resolved\'">\n                    ';
 if (obj.showThumbnail) { ;
__p += '\n                        <img class="' +
((__t = ( obj.local.mcAttachmentThumbnail )) == null ? '' : __t) +
'" data-model-bind="attr : {src : model.dataURI}">\n                    ';
 } else { ;
__p += '\n                        <i class="' +
((__t = ( obj.local.mcAttachmentIcon )) == null ? '' : __t) +
' fa ' +
((__t = ( obj.iconClass )) == null ? '' : __t) +
'"></i>\n                    ';
 } ;
__p += '\n                </span>\n                <i data-name=\'remove-attachment\' class="fa fa-times ' +
((__t = ( obj.local.mcAttachmentRemove )) == null ? '' : __t) +
' text-muted"></i>\n            </div>\n        </div>\n    </div>\n';
return __p
}
};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

_ = __webpack_require__(2);
module.exports = {
    "template": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class="' +
((__t = ( obj.local.mcHeadsUp )) == null ? '' : __t) +
'">\n        <div class="' +
((__t = ( obj.local.headsUpTopline )) == null ? '' : __t) +
'" data-model-bind="css: {\'' +
((__t = ( obj.local.headsUpHasExp )) == null ? '' : __t) +
'\': computed.offerDisplay.offerExpDateTxt}">\n            <span class="' +
((__t = ( obj.local.headsUpExpDate )) == null ? '' : __t) +
'" data-model-bind="visible: computed.offerDisplay.offerExpDateTxt">\n                Expires <span data-model-bind="text: computed.offerDisplay.offerExpDateTxt"></span>\n            </span>\n        </div>\n        <div class="' +
((__t = ( obj.local.headsUpNotif )) == null ? '' : __t) +
'" data-model-bind="\n                html: computed.offerDisplay.notificationMsg,\n                visible: computed.offerDisplay.notificationMsg\n            "></div>\n        <div class="' +
((__t = ( obj.local.headsUpPCS )) == null ? '' : __t) +
'" data-model-bind="\n            html: computed.offerDisplay.pcsNotification,\n            visible: computed.offerDisplay.pcsNotification\n        "></div>\n        <div class="' +
((__t = ( obj.local.headsUpContent )) == null ? '' : __t) +
'">\n            <div class="' +
((__t = ( obj.local.headsUpThumbnail )) == null ? '' : __t) +
'">\n                <a href="' +
((__t = ( obj.pdpUrl )) == null ? '' : __t) +
'" target="_blank">\n                    <img src="' +
((__t = ( obj.thumbnail )) == null ? '' : __t) +
'" />\n                </a>\n            </div>\n\n            <div class="' +
((__t = ( obj.local.headsUpInfo )) == null ? '' : __t) +
'">\n                <div class="' +
((__t = ( obj.local.headsUpTitle )) == null ? '' : __t) +
'">\n                    <a href="' +
((__t = ( obj.pdpUrl )) == null ? '' : __t) +
'" target="_blank">' +
((__t = ( obj.item.title )) == null ? '' : __t) +
'</a>\n                </div>\n                <div>\n                    ';
 obj.prices.map(function (price) { ;
__p += '\n                        <div class="' +
((__t = ( obj.local.headsUpPrice )) == null ? '' : __t) +
'">\n                            <span class="' +
((__t = ( obj.local.priceLabel )) == null ? '' : __t) +
'">\n                                ' +
((__t = ( price.label )) == null ? '' : __t) +
'\n                            </span>\n                            ';
 if (price.callout) { ;
__p += '\n                                <span class="' +
((__t = ( obj.local.headsUpCallout )) == null ? '' : __t) +
'" data-append="' +
((__t = ( price.callout )) == null ? '' : __t) +
'"></span>\n                            ';
 } ;
__p += '\n                            ';
 if (price.value) { ;
__p += '\n                                ' +
((__t = ( price.value )) == null ? '' : __t) +
'\n                                ';
 if (obj.isSoldIndividually) { ;
__p += '\n                                    <span class="' +
((__t = ( obj.local.headsUpPerItem )) == null ? '' : __t) +
'">\n                                        / item\n                                    </span>\n                                ';
 } ;
__p += '\n                            ';
 } ;
__p += '\n                        </div>\n                    ';
 }) ;
__p += '\n                </div>\n                <div class="' +
((__t = ( obj.local.shippingCopy )) == null ? '' : __t) +
'" data-append="shippingCopy"></div>\n            </div>\n\n            <div class="' +
((__t = ( obj.local.headsUpCta )) == null ? '' : __t) +
'" data-append="headsUpCta"></div>\n        </div>\n    </div>\n';
return __p
}
};

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

_ = __webpack_require__(2);
module.exports = {
    "conversationSummary": function(obj) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class=\'list-group-item ' +
((__t = ( obj.local.mcConversationSummary )) == null ? '' : __t) +
'\' data-model-bind=\'css : {"' +
((__t = ( obj.local.bgColorReadMessage )) == null ? '' : __t) +
'" : !model.unreadMessagesCount}\'>\n        <div class=\'row\'>\n            <div class=\'col-xs-2 ' +
((__t = ( obj.local.mcInboxCol )) == null ? '' : __t) +
' text-center\'><!-- thumbnail -->\n                ';
 if (!obj.isBuyer && !obj.item) { ;
__p += '\n                    <strong class="' +
((__t = ( obj.local.mcInboxStorefront )) == null ? '' : __t) +
' vertically-horizontally-centered" data-tn="mc-message-category">General Inquiry</strong>\n                ';
 } else if (obj.thumbnail) { ;
__p += '\n                    <img data-name=\'item-thumbnail\' class=\'vertically-horizontally-centered ' +
((__t = ( obj.local.thumbnail )) == null ? '' : __t) +
'\' src="' +
((__t = ( obj.thumbnail )) == null ? '' : __t) +
'"/>\n                ';
 } ;
__p += '\n                ';
 if (!obj.isBuyer && obj.item && obj.itemDealerReference) { ;
__p += '\n                    <div class="' +
((__t = ( obj.local.mcItemRefNum )) == null ? '' : __t) +
' horizontally-centered">\n                        REF # ' +
((__t = ( obj.itemDealerReference )) == null ? '' : __t) +
'\n                    </div>\n                ';
 } ;
__p += '\n            </div>\n            <div class="col-xs-2 ' +
((__t = ( obj.local.mcInboxCol )) == null ? '' : __t) +
' hidden-xs">\n                <div class="' +
((__t = ( obj.local.otherPersonsName )) == null ? '' : __t) +
'"><!-- other persons name -->\n                    <div class="' +
((__t = ( obj.local.mcDealerToFromLine )) == null ? '' : __t) +
'" data-tn="mc-message-dealer">\n                        ' +
__e( obj.otherMemberDisplayName ) +
'\n                    </div>\n                    ';
 if (obj.isTrade) { ;
__p += '\n                        <span class="label ' +
((__t = ( obj.local.badgeTrade )) == null ? '' : __t) +
'">TRADE</span>\n                    ';
 } ;
__p += '\n                </div>\n            </div>\n            <div class="col-sm-4 col-xs-10 ' +
((__t = ( obj.local.mcInboxCol )) == null ? '' : __t) +
'"><!-- message preview -->\n                <div class="' +
((__t = ( obj.local.mcToFromLine )) == null ? '' : __t) +
' visible-xs">\n                    ' +
__e( obj.otherMemberDisplayName ) +
'\n                    ';
 if (obj.isTrade) { ;
__p += '\n                        <span class="label ' +
((__t = ( obj.local.badgeTrade )) == null ? '' : __t) +
'">TRADE</span>\n                    ';
 } ;
__p += '\n                </div>\n                <div class=\'' +
((__t = ( obj.local.messageIndicators )) == null ? '' : __t) +
' visible-xs\' data-append=\'indicatorsMobile\'></div>\n                <div class="' +
((__t = ( obj.local.messagePreviewRow )) == null ? '' : __t) +
' ' +
((__t = ( obj.local.mcConversationBodySummary )) == null ? '' : __t) +
'\n                    ' +
((__t = ( obj.unreadMessagesCount ? obj.local.unreadIndicator : '')) == null ? '' : __t) +
'\n                    ' +
((__t = ( obj.isLatestMessageSender ? obj.local.replyIndicator : '' )) == null ? '' : __t) +
'\n                    " data-tn="mc-conversation-body">' +
__e( obj.latestMessage ) +
'\n                </div>\n                <div class="visible-xs ' +
((__t = ( obj.statusComplete ? obj.local.statusComplete : obj.local.statusPending )) == null ? '' : __t) +
'">\n                    ';
 if (obj.statusMessage) { ;
__p += '\n                        <div data-name=\'status-message\' class=\'' +
((__t = ( obj.local.statusMessage )) == null ? '' : __t) +
'\'>\n                            ' +
((__t = ( obj.statusMessage )) == null ? '' : __t) +
'\n                        </div>\n                    ';
 } ;
__p += '\n                </div>\n            </div>\n            <div class=\'col-xs-2 hidden-xs ' +
((__t = ( obj.local.mcInboxCol )) == null ? '' : __t) +
' ' +
((__t = ( obj.local.statusColumn )) == null ? '' : __t) +
' ' +
((__t = ( obj.statusComplete ? obj.local.statusComplete : obj.local.statusPending )) == null ? '' : __t) +
'\'><!-- offer -->\n                    ';
 if (obj.statusMessage) { ;
__p += '\n                        <div class="' +
((__t = ( obj.local.statusWrapper )) == null ? '' : __t) +
'">\n                            <div class=\'hidden-xs ' +
((__t = ( obj.local.statusMessage )) == null ? '' : __t) +
'\'>' +
((__t = ( obj.statusMessage )) == null ? '' : __t) +
'</div>\n                        </div>\n                    ';
 } ;
__p += '\n            </div>\n            <div class=\'col-xs-2 hidden-xs ' +
((__t = ( obj.local.mcInboxCol )) == null ? '' : __t) +
'\'><!-- spacer for free-floating date column -->\n            </div>\n            <div class=\'' +
((__t = ( obj.local.mcInboxRightColContents )) == null ? '' : __t) +
'\' data-tn="mc-message-date">\n                <span class="hidden-xs">' +
__e( obj.displayDate ) +
'</span>\n                <span class="visible-xs">' +
__e( obj.displayDateMobile ) +
'</span>\n                <div class=\'hidden-xs\' data-append=\'indicatorsDesktop\'></div>\n            </div>\n        </div>\n        <div class=\'' +
((__t = ( obj.local.mcConversationSummaryOverlay )) == null ? '' : __t) +
'\'></div>\n    </div>\n';
return __p
},
    "indicators": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    ';
 if (obj.numberOfAttachments) { ;
__p += '\n        <span><i class="fa fa-paperclip"></i><span>\n    ';
 } ;
__p += '\n';
return __p
}
};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

_ = __webpack_require__(2);
module.exports = {
    "conversationFilterSelect": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <select id="conversationFilter">\n        ';
 _.each(obj.filters, function (label, value) { ;
__p += '\n            <option value="' +
((__t = ( value )) == null ? '' : __t) +
'" ' +
((__t = ( obj.selectedFilter.value === value ? 'selected' : '' )) == null ? '' : __t) +
' > ' +
((__t = ( label )) == null ? '' : __t) +
'</option>\n        ';
 }); ;
__p += '\n    </select>\n';
return __p
},
    "conversationFilterDropdown": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div id="filterDropdownContainer" class="bs dropdown mc-filter-button-container">\n        <button type="button" class="btn btn-default btn-sm dropdown-toggle mc-filter-button" data-toggle="dropdown">\n            <span class="pull-left mc-filter-button-selected" data-model-bind="text: computed.selectedfilterLabel"></span>\n            <span class="pull-right caret"></span>\n        </button>\n        <ul class="dropdown-menu gtm-message-inbox-view-selector">\n            ';
 _.each(obj.filters, function (label, value) { ;
__p += '\n                <li data-model-bind="visible: computed.selectedfilterValue !== \'' +
((__t = ( value )) == null ? '' : __t) +
'\'">\n                    <a\n                        href="#filter-inbox"\n                        class="mc-filter-button-value"\n                        data-value="' +
((__t = ( value )) == null ? '' : __t) +
'"\n                    >' +
((__t = ( label )) == null ? '' : __t) +
'</a>\n                </li>\n            ';
 }); ;
__p += '\n        </ul>\n    </div>\n';
return __p
}
};

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

_ = __webpack_require__(2);
module.exports = {
    "messageCenter": function(obj) {
var __t, __p = '';
__p += '\n    <div data-model-bind=\'visible: state.activeViewKey === "inbox"\'>\n        <div class=\'row\'>\n            <div class=\'col-xs-3\'>\n                <div class=\'' +
((__t = ( obj.local.refreshClock )) == null ? '' : __t) +
'\' data-append=\'refreshClock\'></div>\n            </div>\n            <div class=\'col-xs-9\'>\n                <div data-append=\'search\'></div>\n                <div data-append=\'searchParamsIndicator\'></div>\n            </div>\n        </div>\n        <h1 class=\'' +
((__t = ( obj.local.mcHeader )) == null ? '' : __t) +
'\' data-tn="mc-inbox-header" data-append=\'inboxHeader\'></h1>\n        <div data-append=\'inbox\'></div>\n    </div>\n    <div class=\'' +
((__t = ( obj.local.mcConversationWrapper )) == null ? '' : __t) +
' row\'>\n        <div class=\'col-xs-12\' data-model-bind=\'visible: state.activeViewKey !== "inbox" && state.pendingViewKey !== "inbox"\'>\n            <div class=\'' +
((__t = ( obj.local.mcAllConversationsBlock )) == null ? '' : __t) +
'\'>\n                <span\n                    data-mc-route-action=\'showIndex\'\n                    class=\'' +
((__t = ( obj.local.mcAllConversationsLink )) == null ? '' : __t) +
'\'\n                ><i class="fa fa-angle-left"></i>&nbsp;&nbsp;' +
((__t = ( obj.copy('all conversations') )) == null ? '' : __t) +
'</span>\n                <span\n                    data-mc-route-action=\'showIndexUnread\'\n                    data-model-bind=\'visible: state.totalUnreadConversationCount > 0\'\n                    class="' +
((__t = ( obj.local.totalUnreadConversationCount )) == null ? '' : __t) +
'"\n                >( <span data-model-bind=\'text: state.totalUnreadConversationCount\'></span> ' +
((__t = ( obj.copy('new') )) == null ? '' : __t) +
' )</span>\n            </div>\n        </div>\n        <div data-append=\'error\' data-model-bind=\'visible: state.activeViewKey==="error"\'></div>\n        <div data-append=\'conversation\' data-model-bind=\'visible: state.activeViewKey==="conversation"\'></div>\n    </div>\n    <div data-append=\'loading\' data-model-bind=\'visible: state.activeViewKey==="loading"\'></div>\n';
return __p
}
};

/***/ },
/* 38 */
/***/ function(module, exports) {

module.exports = require("ellipsis-overflow");

/***/ },
/* 39 */
/***/ function(module, exports) {

module.exports = require("lodash.foreach");

/***/ },
/* 40 */
/***/ function(module, exports) {

module.exports = require("lodash.invert");

/***/ },
/* 41 */
/***/ function(module, exports) {

module.exports = require("moment");

/***/ },
/* 42 */
/***/ function(module, exports) {

module.exports = require("moment-locale-builder");

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _view = __webpack_require__(10);

Object.defineProperty(exports, 'Attachment', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_view).default;
  }
});

var _view2 = __webpack_require__(14);

Object.defineProperty(exports, 'AttachmentIndicator', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_view2).default;
  }
});

var _ComposeMessage = __webpack_require__(15);

Object.defineProperty(exports, 'ComposeMessage', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ComposeMessage).default;
  }
});

var _Conversation = __webpack_require__(16);

Object.defineProperty(exports, 'Conversation', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Conversation).default;
  }
});

var _ConversationError = __webpack_require__(17);

Object.defineProperty(exports, 'ConversationError', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ConversationError).default;
  }
});

var _view3 = __webpack_require__(18);

Object.defineProperty(exports, 'ConversationHeadsUp', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_view3).default;
  }
});

var _view4 = __webpack_require__(19);

Object.defineProperty(exports, 'ConversationSummary', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_view4).default;
  }
});

var _FlagConversation = __webpack_require__(20);

Object.defineProperty(exports, 'FlagConversation', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FlagConversation).default;
  }
});

var _view5 = __webpack_require__(21);

Object.defineProperty(exports, 'InboxFilter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_view5).default;
  }
});

var _InboxWrapper = __webpack_require__(22);

Object.defineProperty(exports, 'InboxWrapper', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InboxWrapper).default;
  }
});

var _MessageCenter = __webpack_require__(23);

Object.defineProperty(exports, 'MessageCenter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MessageCenter).default;
  }
});

var _MessageSummary = __webpack_require__(24);

Object.defineProperty(exports, 'MessageSummary', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MessageSummary).default;
  }
});

var _momentLocales = __webpack_require__(9);

Object.defineProperty(exports, 'momentLocales', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_momentLocales).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }
/******/ ]);
//# sourceMappingURL=bundle.js.map


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/~/web-mc/dist/bundle.js
// module id = 201
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55